import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Folders } from './Folders';
import { Files } from './Files';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { useDispatch, useSelector } from 'react-redux';

export const FilterContentSection = props => {
	const {
		filterActive
	} = props;

	const { user } = useSelector(state => state.Profile);

	const query = useMemo(() => {
		if (filterActive === 'Important') {
			return {
				user_favourite_list: {
					$listContains: user._id,
				},
				disable: {
					$eq: false,
				},
			};
		}
		if (filterActive === 'Recents') {
			return {
				disable: {
					$eq: false,
				},
				// sort: ['creation_date:desc'],
			};
		}
		if (filterActive === 'Deleted') {
			return {
				disable: {
					$eq: true,
				},
			};
		}
	}, [filterActive]);

	return (
		<div className='file-manager-content w-100 p-3 py-0'>
			<div className='mx-n3 pt-4 px-4 file-manager-content-scroll'>
				<Files
					query={query}
				/>
			</div>
		</div>
	);
};
